
export default {
  head() {
    return {
      title: this.$i18n.t('Terms & Conditions'),
    }
  },
}
